import React, { useEffect, useReducer } from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";
import {
  getChargingSiteBundles,
  getDayshareOneTimeParkingSlot,
} from "../../actions/commonActions";
import { useDispatch, useSelector } from "react-redux";
import Switch from "../Switch";
import { setPageTitle } from "../../utils/helper";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const MOMENT_FORMAT = "yyyy-MM-DD HH:mm";

const MOMENT_12HOUR_TIME_FORMAT = "hh:mm A";

const MOMENT_TIME_FORMAT = "HH:mm";

const MOMENT_DATE_FORMAT = "yyyy/MM/DD";

const initialState = {
  ev_charging_site_bundle_id: "",
  parking_slot_id: "",
  start_date_time: null,
  no_of_hours: 1,
};

function reducer(state, { field, value, type }) {
  if (type == "UPDATE_ALL") return value;
  // if (type == "CLEAR_ALL") return {}
  return {
    ...state,
    [field]: value,
  };
}
export default function ({ showNewEventModal, onSubmit, onClose, date }) {
  const dispatch = useDispatch();

  const [state, setState] = useReducer(reducer, initialState);

  const { chargingSiteBundles, parkingSlotsList } = useSelector(
    (reduxState) => reduxState.common
  );

   console.log("checking values in modal: ", chargingSiteBundles)

  useEffect(() => {
    if (chargingSiteBundles?.evChargingSiteBundles?.length > 0) {
      const { ev_charging_site_bundle_id } = chargingSiteBundles?.evChargingSiteBundles[0];
      fetchParkingSlots(
        ev_charging_site_bundle_id,
        state.start_date_time,
        state.no_of_hours
      );
      setState({
        field: "ev_charging_site_bundle_id",
        value: ev_charging_site_bundle_id,
      });
    }
  }, [chargingSiteBundles?.evChargingSiteBundles, state.start_date_time]);

  useEffect(() => {
    if (parkingSlotsList.length > 0) {
      const { parking_slot_id } = parkingSlotsList[0];
      setState({
        field: "parking_slot_id",
        value: parking_slot_id,
      });
    }
  }, [parkingSlotsList]);

  useEffect(() => {
    setState({ value: initialState, type: "UPDATE_ALL" });
  }, [initialState]);

  useEffect(() => {
    setPageTitle("Add New Booking");
    let ev_charging_site_id = localStorage.getItem("ev_charging_site_id");
    getChargingSiteBundles(dispatch, ev_charging_site_id);

    if (state.ev_charging_site_bundle_id) {
      fetchParkingSlots(
        state.ev_charging_site_bundle_id,
        state.start_date_time,
        state.no_of_hours
      );
    }
  }, []);

  const fetchParkingSlots = (
    ev_charging_site_bundle_id,
    start_time,
    booking_duration
  ) => {
    let selected_start_time = start_time || moment().format(MOMENT_12HOUR_TIME_FORMAT);
    
    start_time = start_time || moment().format(MOMENT_12HOUR_TIME_FORMAT);
    let ev_charging_site_id = localStorage.getItem("ev_charging_site_id");

    // Get Date Today
    let utc_start_time = moment().format(MOMENT_DATE_FORMAT);

    // add time to today as local time
    const datetime = utc_start_time + " " + start_time;

    // utc_start_time = moment(datetime).format(MOMENT_FORMAT);
    utc_start_time = moment(datetime); //.format("yyyy/MM/DD HH:mm");

    // convert local datetime to utc and format to get only utc time -> to send to server
    utc_start_time = moment(utc_start_time).utc().format(MOMENT_TIME_FORMAT);


    let exactDate = constructRightDateTime(date, selected_start_time);
    exactDate = exactDate.format("Y-M-D");

    console.log("date=======", date);  
    console.log("utc_start_time=======", utc_start_time);  
    console.log("selected_start_time=======", selected_start_time);  
    console.log("exactDate=======", exactDate);  

    const payload = {
      ev_charging_site_id,
      ev_charging_site_bundle_id: ev_charging_site_bundle_id,
      // start_date: date,
      start_date: exactDate,
      start_time: utc_start_time,
      booking_duration,
    };

    getDayshareOneTimeParkingSlot(dispatch, payload);
  };

  const onChange = (e) => {
    if (e.target.name == "ev_charging_site_bundle_id") {
      fetchParkingSlots(
        e.target.value,
        state.start_date_time,
        state.no_of_hours
      );
    }
    if (e.target.name == "start_date_time") {
      fetchParkingSlots(
        state.ev_charging_site_bundle_id,
        e.target.value,
        state.no_of_hours
      );
    }
    if (e.target.name == "no_of_hours") {
      fetchParkingSlots(
        state.ev_charging_site_bundle_id,
        state.start_date_time,
        e.target.value
      );
    }
    setState({ field: e.target.name, value: e.target.value });
  };

  const onStartDateTimeChange = (date) => {

    let time = moment(date).format(MOMENT_12HOUR_TIME_FORMAT);
    fetchParkingSlots(
      state.ev_charging_site_bundle_id,
      time,
      state.no_of_hours
    );

    setState({ field: "start_date_time", value: time });
  };
  

  const constructRightDateTime = (datePart, timePart) => {
    let dateTime = `${datePart} ${timePart}`;
    dateTime = moment(dateTime, "Y-M-D hh:mm A");
    dateTime = moment(dateTime.utc());
    return dateTime;
  }


  const onFormSubmit = (e) => {
    e.preventDefault();
    const parkingSlot = parkingSlotsList.filter(
      (p) => p.parking_slot_id == state.parking_slot_id
    );
    if (parkingSlot.length > 0) {

      const start_date_time = moment
        .utc(parkingSlot[0].start_date_time)
        .format(MOMENT_FORMAT);
      // const start_date_timef = moment
      //   .utc(parkingSlot[0].start_date_time)
      //   .format(MOMENT_FORMAT);

      let end_date_time = moment
        .utc(start_date_time)
        .add(state.no_of_hours, "hours")
        .format(MOMENT_FORMAT);
        console.log("parkingSlot[0].start_date_time======", parkingSlot[0].start_date_time);
        console.log("start_date_time======", start_date_time);
        console.log("end_date_time======", end_date_time);
        // end_date_time = moment(end_date_time).format(MOMENT_FORMAT);
      // const end_date_timef = moment.utc(end_date_time).format(MOMENT_FORMAT);
      onSubmit({
        ...state,
        driver_id: parseInt(localStorage.getItem("driver_id")),
        start_date_time,
        end_date_time,
      });
    }
  };

  const onParkingSlotChecked = (e) => {
    setState({ field: "parking_slot_id", value: e.target.id });
  };

  return (
    <div>
      <Modal show={showNewEventModal} onHide={onClose} centered>
        <Modal.Header>
          {/* <h5 className="modal-title">Add New Booking</h5> */}
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={onClose}
          >
            &times;
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="container parentDiv">
            <form onSubmit={onFormSubmit}>
              <div className="form-group">
                <h6>Booking Day: {moment(date).format("MMMM Do, dddd")}</h6>
              </div>

              {/* <div>
                <h2> {chargingSiteBundles[0]?.name} </h2>

                <h6> Charging Fees:  </h6>
              </div> */}

              <div class="form-group">
                <label for="ev_charging_site_bundle_id">Plan</label>
                <select
                  className="form-control color"
                  name="ev_charging_site_bundle_id"
                  onChange={onChange}
                  id="ev_charging_site_bundle_id"
                >
                  <option value="" disabled>
                    Select Plan
                  </option>
                  {chargingSiteBundles?.evChargingSiteBundles?.length > 0 &&
                    chargingSiteBundles?.evChargingSiteBundles.map((bundle, index) => {
                      return (
                        <option
                          key={index}
                          value={chargingSiteBundles?.flexShareBundles?.length>0? chargingSiteBundles?.flexShareBundles[0]?.ev_charging_site_bundle_id: bundle.ev_charging_site_bundle_id}
                        >
                          {chargingSiteBundles?.flexShareBundles?.length>0? chargingSiteBundles?.flexShareBundles[0]?.name:bundle.name}
                        </option>
                      );
                    })}
                </select>
              </div>
              <div className="row">
                <div className="col-6">
                  <div class="form-group1 ">
                    <label for="start_date_time">Time</label>
                    <DatePicker
                      selected={false}
                      placeholderText={"Now"}
                      onChange={onStartDateTimeChange}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      className="form-control"
                      value={state.start_date_time}
                    />
                  </div>
                </div>
                <div className="col-6">

                  <div class="form-group ">
                    <label for="no_of_hours">Hours</label>
                    <select
                      onChange={onChange}
                      id="no_of_hours"
                      name="no_of_hours"
                      class="form-control"
                    >
                      {(chargingSiteBundles?.flexShareBundles?.length > 0 ? [1,2,3,4,5,6,7,8,9,10,11,12] : [1,2]).map((n) => (
        <option key={n} value={n}>{n}</option> // Adding key prop to each option
    ))}
                    </select>
                  </div>
                
                </div>
                
              </div>

              <div class="form-group mx-from">
                <label for="parking_slot_id">Select a Parking Slot</label>
                <div>
                  <p className="mb-2">Proposed - next available time</p>
                  {parkingSlotsList.length > 0 &&
                    parkingSlotsList.map((ps, index) => {
                      return (
                        <div class="row parking-slots-list">
                          <div className="col-3">
                            <Switch
                              onChange={onParkingSlotChecked}
                              value={ps.parking_slot_id}
                              selected={state.parking_slot_id}
                            />
                          </div>
                          <div className="col-2">
                            <label>{ps?.parkingSlot?.visible_number}</label>
                          </div>
                          <div className="col-7">
                            <label>
                              {moment(
                                moment.utc(ps.start_date_time).format()
                              ).format(MOMENT_12HOUR_TIME_FORMAT)}
                              {ps.currency_code}
                            </label>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>

              <button type="submit" class="btn btn-primary green-two-bg">
                Book
              </button>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
